// Generated by scripts/sync-stage-labels.mjs from backend/app/tools/candidate.py.
export const STAGE_LABEL: Record<string, string> = {
  "sourced": "Sourced",
  "qualified": "Qualified — ready to send",
  "in_review": "In review",
  "screen": "Selected for screen",
  "screened": "Screened",
  "hm_round": "Selected for HM interview",
  "hm_assessed": "HM interview held",
  "panel": "Advanced to panel",
  "debrief": "Debriefed",
  "offer_approved": "Offer approved",
  "alternate": "Held as alternate",
  "offer": "Offer out",
  "offer_accepted": "Offer Accepted",
  "hris_hired": "HRIS Hired",
  "hired": "Offer Accepted",
  "declined": "Declined",
  "reneged": "Reneged",
  "held": "Held",
  "not_selected": "Not selected",
  "passed_on": "Passed on",
  "withdrawn": "Withdrawn",
  "dispositioned": "Dispositioned"
};
